<template>
  <section id="header"
           v-if="headerContext"
           v-bind="headerContext.properties">

    <!--    <pre><code>{{ context }}</code></pre>-->
    <template
        v-if="headerContext.properties && headerContext.properties.parallax">

      <custom-parallax
          v-for="(oneParallax, index) in headerContext.properties.parallax"
          :key="index"
          :parallax="oneParallax"
          :defaultStyle="headerContext.defaultStyle">

        <template v-if="headerContext && headerContext.sections">

          <template
              v-for="(section, i) in headerContext.sections">
            <dynamic-section
                :key="i"
                :context="section"
            />
          </template>

        </template>

      </custom-parallax>

    </template>

    <template v-else-if="headerContext && headerContext.sections">

      <template
          v-for="(section, i) in headerContext.sections"
      >
        <dynamic-section
            :key="i"
            :context="section"
        />

      </template>
    </template>

  </section>
</template>

<script>
import DynamicSection from "@/components/DynamicSection";
import CustomParallax from "@/components/CustomParallax";
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'Header',
  components: {
    CustomParallax,
    DynamicSection
  },

  mixins: [globalMixins],

  props: {
    context: {
      type: Object
    }
  },

  data() {
    return {
      headerContext: null
    }
  },

  async created() {
    if (this.context) {
      this.headerContext = this._.cloneDeep(this.context);
      await this.checkFixProperties(this.headerContext, true);
    }
  },

  watch: {
    async context(to) {
      this.headerContext = this._.cloneDeep(to);
      setTimeout(async () => {
        await this.checkFixProperties(this.headerContext, true);
      }, 100);
    }
  }
}
</script>

<style synced>
@media (max-width: 375px) {
  .reliable-source .white--text {
    font-size: 22px;
  }
}

</style>